'use client'

import React, { createContext, ReactElement, ReactNode } from 'react'
import { Dictionary, DictionaryModel, ReplacerObject } from '../../../MyStichtingOpenHelpers/src/static'

interface ComponentTranslationProviderValue {
    getLabel: ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined) => string
}

export const ComponentTranslationContext = createContext<ComponentTranslationProviderValue>({
    getLabel: ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined) => defaultValue ?? key,
})

interface ComponentTranslationProviderProps {
    children: ReactNode
    dictionary: DictionaryModel // translations fetched from CMS
}

export const ComponentTranslationProvider = ({
    children,
    dictionary = {},
}: ComponentTranslationProviderProps): ReactElement => {
    const getLabel = ([key, defaultValue]: string[], replacer?: ReplacerObject | undefined): string => {
        const value = Dictionary.getText(dictionary, key, replacer)
        if (value === key && defaultValue) return defaultValue
        return value ?? key
    }
    const providerValue: ComponentTranslationProviderValue = { getLabel }

    return <ComponentTranslationContext.Provider value={providerValue}>{children}</ComponentTranslationContext.Provider>
}
